window.$window = $(window);
window.isSP = false;
window.pageID = $('.l-container').attr('id');

var ScrollMagicObject = require('ScrollMagic');
window.ScrollMagic = ScrollMagicObject.Controller;
window.ScrollScene = ScrollMagicObject.Scene;
require('ScrollMagicPlugin');
require('ScrollMagicDebug');

var CommonController = require('./controller/CommonController');
var IndexController = require('./controller/IndexController');
var CompanyController = require('./controller/CompanyController');
var ServiceController = require('./controller/ServiceController');
var NewsController = require('./controller/NewsController');
var IrController = require('./controller/IrController');
var RecruitController = require('./controller/RecruitController');

new CommonController();
if (pageID === 'top') {
    new IndexController();
}
if (pageID === 'company') {
    new CompanyController();
}
if (pageID === 'service') {
    new ServiceController();
}
if (pageID === 'news') {
    new NewsController();
}
if (pageID === 'ir') {
    new IrController();
}
if (pageID === 'recruit') {
    new RecruitController();
}


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/app.js
 **/